module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[98]463.c804f70.woff2";